<template>
    <div>
        <h5>How long would you like to park for?</h5>
        <select class="form-control v2-styles dropdown-arrow" name="booking_duration" v-model="bookingDuration">
            <option v-for="(option, index) in bookingDurationOptions" :value="option.minutes" :key="index">
                {{ option.label }}
            </option>
        </select>
        <template v-if="bookingDuration === 1441">
            <h5>Departing At</h5>
            <div class="form-groups">
                <div class="form-group">
                    <div class="input-chevron-icon" />
                    <datepicker
                        class="datepicker form-control v2-styles dropdown-arrow"
                        name="end_date"
                        id="end_date"
                        v-model="end_date"
                        :options="endDateConfig"
                    />
                </div>
                <div class="form-group">
                    <div class="input-chevron-icon" />
                    <timepicker
                        class="timepicker form-control v2-styles dropdown-arrow"
                        name="end_time"
                        id="end_time"
                        v-model="end_time"
                        :options="endTimeConfig"
                    />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import moment from 'moment';
    import { minimumShortTermDateNow } from '../../../../modules/dates';
    import storeFormSync from '../../../../store/form-sync';
    import { mapReducers } from '../../../../modules/reducer';
    import SaneDates from '../../../mixins/SaneDates';

    export default {
        name: 'book-now',

        mixins: [SaneDates],

        data() {
            return {
                bookingDuration: 180,
            };
        },

        computed: {
            ...storeFormSync([
                'booking.reservation_details.bookings[0].start_date',
                'booking.reservation_details.bookings[0].start_time',
                'booking.reservation_details.bookings[0].end_date',
                'booking.reservation_details.bookings[0].end_time',
                'booking.overDay',
            ]),

            ...mapReducers('$store.state.booking.reservation_details', 'booking/updateReservationData', [
                'booking_type',
            ]),

            /**
             * Get the booking durations
             * @return {Array} options
             */
            bookingDurationOptions() {
                // Create a new array with 48 items (30 minute increments over 24 hours = 48 objects)
                const options = Array.from(new Array(48)).map((_, i) => {
                    // Total amount of minutes for the object (index + 1) * 30
                    const totalMinutes = (i + 1) * 30;
                    // divide minutes by 60 and round down to get number of total hours
                    const hour = Math.floor(totalMinutes / 60);
                    // minutes left over (either 30 or 0)
                    const minute = totalMinutes - (hour * 60);
                    const time = { hour, minute};

                    const label = Object.keys(time)
                        .filter((val) => time[val])
                        .map((val) => `${ time[val] } ${ time[val] === 1 ? val : `${val}s`}` )
                        .join(' ');

                    // Return the relevant data as an object into the array
                    return {
                        minutes: totalMinutes,
                        label: label,
                    };
                });

                options.push({
                    minutes: 1441,
                    label: 'More than 24 hours',
                });

                return options;
            },

            trueEndTimeConfig() {
                if (this.overDay) {
                    return {
                        min: moment(this.start_time).add(1, 'hour'),
                    };
                }

                return this.endTimeConfig;
            },
        },

        watch: {
            bookingDuration: {
                handler(val) {
                    this.$store.commit('booking/setDuration', val);

                    let endDateTime = minimumShortTermDateNow().add(val, 'minutes');

                    if (val === 1441) {
                        endDateTime = minimumShortTermDateNow().add(1441, 'minutes').ceil(30, 'minutes');
                        this.$store.commit('booking/setOverDay', true);
                    } else {
                        this.$store.commit('booking/setOverDay', false);
                    }

                    const startDateTime = minimumShortTermDateNow();

                    this.start_date = startDateTime.format('DD-MM-YYYY');
                    this.start_time = startDateTime.format('HH:mm');

                    this.end_date = endDateTime.format('DD-MM-YYYY');
                    this.end_time = endDateTime.format('HH:mm');
                },
                immediate: true,
            },
        },

        mounted() {
            this.$store.commit('booking/setDuration', this.bookingDuration);
        },

        methods: {
            minEndDate() {
                if (this.booking_type === 'now') {
                    return moment().add(1, 'days').format('DD-MM-YYYY');
                }

                return this.start_date;
            },
        },
    }
</script>

<style scoped lang="less">
    .form-group {
        position: relative;
    }
</style>
